<template>
  <div class="card">

    <div class="card-header">
      <h3 class="card-header-title">
        Truckl Documents
      </h3>
    </div>

    <div class="card-content">
      <p class="content">
        Below are important documents from Truckl. You can view or download them by clicking on the item you want to review.
      </p>

      <pdf-viewer :show.sync="showModal" :file-path="activeFile" />
      <table class="table is-striped is-narrow is-hoverable is-bordered is-fullwidth">
      <thead>
      <tr>
        <th></th>
        <th>
          File name
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="file in files" :key="file.path">
        <td class="cell-download">
          <a :href="file.path" download>
            <font-awesome-icon icon="file-download" />
            <div class="is-size-7">download</div>
          </a>
        </td>
        <td>
          <a href="" @click.stop.prevent="openPdf(file.path)">
            {{ file.displayName }}
          </a>
        </td>
      </tr>
      </tbody>
    </table>
    </div>

  </div>
</template>

<script>
import { sortBy } from 'lodash-es'
import documents from '@/lookup-data/truckl-files.json'
import PdfViewer from '@/components/ModalDisplayPdf'
export default {
  name: 'TrucklDocuments',

  data() {
    return {
      showModal: false,
      activeFile: ''
    }
  },

  computed: {
    files() {
      return sortBy(documents, 'displayName')
    }
  },

  methods: {
    openPdf(filePath) {
      this.activeFile = filePath
      this.showModal = true
    }
  },

  components: {
    PdfViewer
  }
}
</script>

<style scoped lang="scss">
td {
  vertical-align: middle;
}
.cell-download {
  text-align: center;
}
</style>
